import React from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons"
import styles from "./BookingForm.module.css"
import moment from "moment"

const { Text } = Typography

const MetaItem = ({ icon: Icon, text }) => (
  <div className={styles.tripMetaItem}>
    <Icon className={styles.tripMetaIcon} />
    <Text className={styles.tripMetaText}>{text}</Text>
  </div>
)

MetaItem.propTypes = {
  icon: PropTypes.elementType.isRequired,
  text: PropTypes.string.isRequired
}

const TripDetailsCard = ({  booking, bookingSelections }) => {
  const tripName = booking?.trip?.title || ""
  const dateText = moment(bookingSelections?.date).format("MM-DD-YYYY")
  const timeText = bookingSelections?.timeSlot

  if (!tripName && !dateText && !timeText) return null

  return (
    <>
      {tripName && <div className={styles.tripName}>{tripName}</div>}
      {(dateText || timeText) && (
        <div className={styles.tripMetaRow}>
          {dateText && <MetaItem icon={CalendarOutlined} text={dateText} />}
          {timeText && <MetaItem icon={ClockCircleOutlined} text={timeText} />}
        </div>
      )}
    </>
  )
}

TripDetailsCard.propTypes = {
  booking: PropTypes.object,
  bookingSelections: PropTypes.object
}

export default TripDetailsCard
